import { useContext } from 'react';
import { Input, Button, message } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import Iconfont from '@utils/Iconfont';
import { AppContext } from '@utils/AppContext';
import { MaterialManageContext } from '../../hooks/MaterialManageContext';
import styles from './index.module.scss';

const ContentHeader = (props) => {
    const { globalOrgInfo } = useContext(AppContext);
    const { activeTab } = useContext(MaterialManageContext);
    const isPersonal = globalOrgInfo?.isPersonal;

    const {
        title, total, searchKeyword, onSearch,
        batchMode, onBatchMode,
        selectedList,
        onBatchShare, onBatchMove, onBatchDelete, onBatchCancel,
        onUpload,
    } = props;

    return (
        <div className={styles.ContentHeader}>
            <div className={styles.left}>
                <>
                    <span className={styles.title}>{title}</span>
                    <span className={styles.total}>共{total || 0}个素材</span>
                </>
            </div>
            <div className={styles.right}>
                {batchMode ? (
                    <>
                        <span className={styles.selectedCountInline}>已选择 {selectedList?.length || 0} 项</span>
                        <div className={styles.batchActions}>
                            {!isPersonal && activeTab !== 'enterprise' && (
                                <div className={styles.batchBtn} onClick={() => {
                                    if (!selectedList?.length) {
                                        message.warning('请先选择要操作的素材');
                                        return;
                                    }
                                    onBatchShare();
                                }}>
                                    <Iconfont type="icon-Material-MoveToEnterpriseOutlined" />
                                    <span>分享到企业</span>
                                </div>
                            )}
                            <div className={styles.batchBtn} onClick={() => {
                                if (!selectedList?.length) {
                                    message.warning('请先选择要操作的素材');
                                    return;
                                }
                                onBatchMove();
                            }}>
                                <Iconfont type="icon-Material-FolderMoveOutlined" />
                                <span>移动</span>
                            </div>
                            <div className={`${styles.batchBtn} ${styles.deleteBtn}`} onClick={() => {
                                if (!selectedList?.length) {
                                    message.warning('请先选择要操作的素材');
                                    return;
                                }
                                onBatchDelete();
                            }}>
                                <Iconfont type="icon-Material-DeleteOutlined" />
                                <span>删除</span>
                            </div>
                            <div className={styles.batchBtn} onClick={onBatchCancel}>
                                <span>取消</span>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <Input
                            className={styles.searchInput}
                            placeholder="搜索内容"
                            prefix={<SearchOutlined style={{ color: '#BFBFBF' }} />}
                            value={searchKeyword}
                            onChange={e => onSearch(e.target.value)}
                            onPressEnter={() => onSearch(searchKeyword)}
                            allowClear
                        />
                        <Button
                            icon={<Iconfont style={{fontSize: 15 }} type="icon-Material-BatchOperationOutlined" />}
                            onClick={() => onBatchMode(!batchMode)}
                        >
                            批量操作
                        </Button>
                        <Button type="primary" onClick={onUpload}>
                            上传参考图
                        </Button>
                    </>
                )}
            </div>
        </div>
    );
};

export default ContentHeader;
